export default "__VITE_ASSET__714749ae__"